import {
  Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Course from '../../course.class';
import { RequirementsService } from 'src/app/services/requirements.service';
import { validateCourseDetails } from 'src/app/utils/course-validation.utils';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss'],
})
export class CourseDetailsComponent implements OnInit, OnChanges {
  @Output() stepBack = new EventEmitter<any>();
  @Output() stepForward = new EventEmitter<boolean>();
  @Output() closeDialogEmitter = new EventEmitter<any>();
  @Output() validationChange = new EventEmitter<{ isValid: boolean }>();
  @Input() course: Course;
  @Input() isEditMode: any;
  @Input() isCourseRequestApproval: any;
  formattedCourseDate: any;

  // State reporting requirements
  showStateReportingRequirements = false;
  stateRequirements: { value: number, kid: string, text: string }[] = [];

  constructor(public dialog: MatDialog, private requirementsService: RequirementsService) {
  }

  ngOnInit(): void {
    this.loadStateRequirements();
    const stateGroup = this?.course?.requirementsList?.filter((requirement: any) => requirement?.reportToStateFlag === 1);
    if (stateGroup?.length > 0) {
      this.showStateReportingRequirements = true;
    }
    this.emitValidationStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['course']) {
      this.emitValidationStatus();
    }
  }

  loadStateRequirements() {
    this.requirementsService.getSortedRequirements(
      'requirement', 'ASC', 1, 100, 0,
    );
    this.requirementsService.requirementsData$.subscribe((data: any) => {
      if (!data) return;

      // Filter requirements with reportToStateFlag = 1
      this.stateRequirements = data.rows
        .filter((requirement: any) => requirement.reportToStateFlag === 1)
        .map((requirement: any) => ({
          text: requirement.requirement,
          value: requirement.id,
          kid: requirement.kalpaIdentifier,
        }));
    });
  }

  updateCourseParameter = (event: any, parameter: keyof Course) => {
    const value = event.target.value;

    if (parameter === 'dateOffered') {
      this.course.setProperty(parameter, value);
      this.course.dateOfferedFormatted = value;
      this.emitValidationStatus();
      return;
    }

    if (parameter === 'sessionStartDate') {
      this.course.sessionStartDateFormatted = value;
    } else if (parameter === 'sessionEndDate') {
      this.course.sessionEndDateFormatted = value;
    }

    if (parameter === 'stateRequirementId') {
      const requirement = this.stateRequirements.find((requirement: any) => {
        return requirement.value === value;
      });

      if (requirement) {
        this.course.setProperty('stateRequirementId', requirement.value);
      }
    }

    this.course.setProperty(parameter, value);
    this.emitValidationStatus();
  }

  updateCourse = () => {
    const validation = validateCourseDetails(this.course);
    if (!validation.isValid) {
      return;
    }

    if (this.showStateReportingRequirements && this.course.stateRequirementId) {
      const requirement = this.stateRequirements.find((requirement: any) => requirement.value === this.course.stateRequirementId);
      this.course.setProperty('stateRequirementId', this.course.stateRequirementId);
    }

    this.stepForward.emit(true)
  }

  asyncToggle = ($event: Event) => {
    const value = ($event.target as HTMLInputElement).checked;
    this.course.isAsync = value;
    this.course.setProperty('preRecordedOption', value ? 'ASYNC' : '');

    // this.course.isAsync
    this.course.isAnytime = false;
    // this.course.isAsync ? this.course.sessionStartDate = undefined : null;
    // this.course.isAsync ? this.course.sessionEndDate = undefined : null;
    // this.course.isAsync ? this.course.dateOffered = undefined : null;

    this.emitValidationStatus();
  }

  updateAnytime($event: Event) {
    const value = ($event.target as HTMLInputElement).checked;
    this.course.isAnytime = value;
    this.course.isAsync = false;
    this.course.setProperty('preRecordedOption', value ? 'ANYTIME' : '');
    // this.course.isAnytime ? this.course.sessionStartDate = undefined : null;
    // this.course.isAnytime ? this.course.sessionEndDate = undefined : null;
    
    this.emitValidationStatus();
  }

  checkDisabled = (): boolean => {
    const validation = validateCourseDetails(this.course);
    return !validation.isValid;
  }

  private emitValidationStatus(): void {
    const validation = validateCourseDetails(this.course);
    this.validationChange.emit({ isValid: validation.isValid });
  }

  stepBackward = () => {
    this.stepBack.emit();
  }

  closeDialog = () => {
    this.closeDialogEmitter.emit();
  }

}

